
<div>
  <iframe  style="width:100%;height:700px; border:0;overflow:auto;" title="payment gateway"
   [src]="url"></iframe>
</div>
